import styled from 'styled-components';
import { Snackbar as MuiSnackbar } from '@mui/material';
export var StyledSnackbar = styled(MuiSnackbar).withConfig({
  displayName: "style__StyledSnackbar",
  componentId: "sc-1gqfbfh-0"
})([".MuiSnackbarContent-root{background-color:", ";}.MuiSnackbarContent-message{max-width:30rem;}"], function (_ref) {
  var theme = _ref.theme,
    type = _ref.type;
  var color = null;
  switch (type) {
    case 'success':
      color = theme.green;
      break;
    case 'info':
      color = theme.blue;
      break;
    case 'loading':
      color = theme.blue;
      break;
    case 'warning':
      color = theme.yellow;
      break;
    case 'error':
      // eslint-disable-next-line prefer-destructuring
      color = theme.red[500];
      break;
    default:
      color = theme.blue;
      break;
  }
  return color;
});
export var TypedContainer = styled.div.withConfig({
  displayName: "style__TypedContainer",
  componentId: "sc-1gqfbfh-1"
})(["display:flex;align-items:center;justify-content:space-between;.message-container{margin-left:1rem;}svg{color:white;}"]);
export var MessageContainer = styled.div.withConfig({
  displayName: "style__MessageContainer",
  componentId: "sc-1gqfbfh-2"
})(["margin-left:1rem;"]);